import React from "react";
import { Link, NavLink } from "react-router-dom";
import { usePublicPages } from "../../contexts/PublicPagesContext";

/**
 * Renders a Link or NavLink only when the given public page is enabled.
 * Returns null when the page is disabled so CTAs disappear cleanly.
 */
const PublicPageLink = ({
  pageKey,
  as: Component = Link,
  children,
  ...props
}) => {
  const { isPageEnabled } = usePublicPages();

  if (!isPageEnabled(pageKey)) {
    return null;
  }

  return <Component {...props}>{children}</Component>;
};

export { Link as RouterLink, NavLink as RouterNavLink };
export default PublicPageLink;
